// Generated by scripts/i18n-widget.mjs — changes when any translation changes
export const UI_STRINGS_VERSION = '9692edf4f0';
